<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { SeparatorProps } from 'reka-ui';
  import { Separator } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(defineProps<SeparatorProps & { class?: HTMLAttributes['class'] }>(), {
    decorative: true,
    orientation: 'horizontal',
  });

  const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <Separator
    data-slot="separator"
    v-bind="delegatedProps"
    :class="
      cn(
        'bg-border shrink-0',
        orientation === 'vertical' ? 'w-px h-full' : 'h-px w-full',
        props.class,
      )
    "
  />
</template>
